import { Big } from 'big.js';
import { Corridor, EnumCorridorColor, parseBig, QuoteWrapper } from 'quote-domain-core';
import { CorridorService } from './corridor/corridor-service';
import { singleton } from 'tsyringe';

@singleton()
export class QuoteWrapperService {
    constructor(private readonly corridorService: CorridorService) {
    }

    public updateQuoteWrapperColors(quoteWrapper: QuoteWrapper): void {
        Object.assign(quoteWrapper, {
            color: this.getMatchedColor(quoteWrapper),
            existingColor: this.getExistingMatchedColor(quoteWrapper)
        });
    }

    private getMatchedColor(quoteWrapper: QuoteWrapper): string {
        let appliedPrice = new Big(0);
        const globalCorridorQuoteWrapper = new Corridor();
        globalCorridorQuoteWrapper.isNeutral = true;
        for (const serviceLine of quoteWrapper.serviceLines) {
            appliedPrice = appliedPrice.plus(parseBig(serviceLine.appliedPrice));
            const newGlobalCorridor = serviceLine.newQuoteService?.globalCorridor;
            const renewalGlobalCorridor = serviceLine.renewalQuoteService?.globalCorridor;
            if (newGlobalCorridor) {
                this.corridorService.addCorridor(globalCorridorQuoteWrapper, newGlobalCorridor);
            }
            if (renewalGlobalCorridor) {
                this.corridorService.addCorridor(globalCorridorQuoteWrapper, renewalGlobalCorridor);
            }
            if ((newGlobalCorridor?.isNeutral === false) || (renewalGlobalCorridor?.isNeutral === false)) {
                globalCorridorQuoteWrapper.isNeutral = false;
            }
        }
        return quoteWrapper.serviceLines.length
            ? this.corridorService.getMatchedColorByappliedPrice(globalCorridorQuoteWrapper, appliedPrice.toString(), quoteWrapper.nonNegociableArticleColor)
            : EnumCorridorColor.GRAY;
    }

    private getExistingMatchedColor(quoteWrapper: QuoteWrapper): string {
        const globalExistingCorridorQuoteWrapper = new Corridor();
        globalExistingCorridorQuoteWrapper.isNeutral = true;
        let totalAppliedPrice = new Big(0);
        for (const serviceLine of quoteWrapper.serviceLines) {
            const existingService = serviceLine.existingQuoteService;
            const globalCorridor = existingService?.globalCorridor;
            if (globalCorridor) {
                this.corridorService.addCorridor(globalExistingCorridorQuoteWrapper, globalCorridor);
                if (!globalCorridor.isNeutral) {
                    globalExistingCorridorQuoteWrapper.isNeutral = false;
                }
            }
            const appliedPrice = parseBig(existingService?.appliedPrice);
            totalAppliedPrice = totalAppliedPrice.plus(appliedPrice);
        }
        return quoteWrapper.serviceLines.length
            ? this.corridorService.getMatchedColorByappliedPrice(globalExistingCorridorQuoteWrapper, totalAppliedPrice.toString(), quoteWrapper.nonNegociableArticleColor)
            : EnumCorridorColor.GRAY;
    }
}
